import React, { PureComponent } from 'react';
import modalContainer from '../ModalContainer';
import './index.scss'
@modalContainer
class CommonModal extends PureComponent{
  render(){

    const {modalBgColor} = this.props;
    return (
      <div className="common-modal-container" style={{background: modalBgColor}}>
        {this.props.children}
      </div>
    )
  }
}

export default CommonModal